import { Button, notification, Tabs, TabsProps } from "antd";
import React, { JSX } from "react";
import { mdiChevronLeft, mdiChevronRight, mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import { Link } from "react-router-dom";
import LocationsApi from "../../api-services/locations-api.service";
import LocationDropdown from "./LocationDropdown";
import LocationPostcards from "./LocationPostcards";

interface ILocationTabsState {
  selectedCountry: any,
  activeTab: string;
  locations: any[]
}

interface ILocationTabsProps {
  header:JSX.Element, 
  locations: any[], 
  navigators?: boolean, 
  additionalParams?: any
  showMore?: boolean;
  showMoreLink?: string;
}


export default class LocationTabs extends React.Component<ILocationTabsProps> {
  api = new LocationsApi;

  state:ILocationTabsState = {
    selectedCountry: {}, 
    activeTab: "0",
    locations: []
  }

  componentDidUpdate(prevProps: Readonly<ILocationTabsProps>, prevState: Readonly<{}>, snapshot?: any): void {
      var locations = this.props.locations;
      if(prevProps.locations != locations && this.props.locations.length > 0){
        if(this.props.showMore && this.props.showMore == true && this.props.locations.length > 6){
          locations.push({id: 'see-more', name: 'See more', link: this.props.showMoreLink})
        }
        this.setState({selectedCountry: locations[0], locations});
      }    
  }

  changeTab (key) {
    const items = this.props.locations;
    const selected = items[key];

    if(selected){
      this.setState({selectedCountry: selected, activeTab: key.toString()})
    }else{
      if(key == 'see-more'){
        const item = items.find(i => i.id == key);
        window.location.href = item.link;
      }
    }
 }

 prevTab = () => {
  const currentKeyNumber = parseInt(this.state.activeTab);
  var totalLocationsCount = this.props.locations.length;
  //subtract see-more tab in count
  if(this.props.showMore) totalLocationsCount = totalLocationsCount - 1;

  var prevKey = (currentKeyNumber == 0 ? totalLocationsCount : currentKeyNumber) - 1;
  this.setState({activeTab: prevKey.toString()})
 }

 nextTab = () => {
  const currentKeyNumber = parseInt(this.state.activeTab);
  var nextKey = (currentKeyNumber + 1);

  if(nextKey == this.props.locations.length){
    nextKey = 0;
  }

  this.setState({activeTab: nextKey.toString()})
 }

  render(){
    const pluralize = (count: number, noun: string, suffix = 's') =>
      `${count} ${noun}${count > 1 ? suffix : ''}`;

    const listingLink = (locator) => {
      var additionalParams = "";
      if(this.props.additionalParams){
        additionalParams = `&${this.props.additionalParams["key"]}=${this.props.additionalParams["value"]}`
      }
      return `/web/listing?keyword=${locator.name}&location_id=${locator.id}${additionalParams}`;
    }


    var items:TabsProps["items"] = this.state.locations.map((location:any, index)=>{
      return {
        key: location.id == 'see-more' ? 'see-more' : index.toString(),
        label: <>
          {location.name}
        </>,
        children: (
          <div>
            <div className="location-tab-cover">
              <Link to={listingLink(location)} className="country ">
                <img className="country-image" src={`${location.cover}`} />
                <h1 className="country-name"> {location.name} </h1>
                {location.tourCount > 0 && <span className="country-tour-count"> {location.tourCount} Tour Packages </span>}
                <picture className="bottom-logo">
                  <img src="/iceholidays-assets/images/destinations_logo.png"></img>
                </picture>
              </Link>
              {
                (this.props.navigators && this.props.navigators == true && this.props.locations.length > 1) && (
                  <div className="location-tab-navigators">
                    <span onClick={this.prevTab}><Icon path={mdiChevronLeft} size="55px" className="prev-tab"/></span>
                    <span onClick={this.nextTab}><Icon path={mdiChevronRight} size="55px" className="next-tab"/></span>
                  </div>
                )
              }
            </div>
            {
              location.children?.length > 0 && 
              <div className="sub-locations">
                <LocationPostcards locations={location.children.slice(0, 6)} listingLink={(locator)=>listingLink(locator)}/>
                {
                  location.children.length > 6 && <div className="load-more"> <Button type="primary" href={`${this.props.showMoreLink}/${location.id}`}>Load More</Button> </div>
                }
              </div>
            }

            {
              location.topCities?.length > 0 && 
              <div className="top-cities">
                <h2>Top Cities</h2>
                <LocationPostcards locations={location.topCities} listingLink={(locator)=>listingLink(locator)}/>
              </div>
            }
            {
              location.tags?.length > 0 && 
              <div className="more-cities">
                <h2>Browse more {location.name} destination</h2>
                <div className="other-destinations">  
                  {
                    location.tags?.map((city, index)=>{
                      return <Link key={index} to={listingLink(city)}> {city.name} </Link>
                    })
                  }
                </div>
              </div>
            }

            {
              location.highlights?.length > 0 && 
                <div className="highlights">  
                  {
                    location.highlights?.map((city, index)=>{
                      return <Link key={index} to={listingLink(city)}>
                        <div className="tour" style={{backgroundImage:`linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%), url("${city.cover}")`}}>
                          <div className="details"> 
                            <span className="city-name"> {city.name}  </span>
                            <span className="tour-count"> {pluralize(city.tourCount || 0, "tour")} <Icon path={mdiMenuRight} size={1} /> </span>
                          </div>
                        </div>
                      </Link>
                    })
                  }
                </div>
            }
          </div>
        )
      }
    })

    return (
      <div className="location-tabs">
        {this.props.header}

        <LocationDropdown initialValue={this.state.selectedCountry?.name} locations={this.state.locations} selectLocation={(selected)=>this.changeTab(selected)}/>

        <Tabs 
          defaultActiveKey="1" 
          activeKey={this.state.activeTab}
          items={items}
          type="card"
          onChange={(selected)=>this.changeTab(selected)}/>

      </div>
    )
  }
}